<template>
    <div class="pg-answer">
        <div v-if="step === 1" class="step1" :class="{
          'with-bg': baseStyle && (baseStyle.bgSrc || baseStyle.color),
          horizontal: isHorizontal
        }" :style="style">
          <div class="survey_cover_text">
              <div class="TopBgTitle">
                  <p style="text-align: left;">{{base.title}}</p>
              </div>
              <div class="desc_begin" v-html="base.desc"></div>
          </div>
          <div class="submmit" @click="step = 2">{{ isEOZ ? 'Start Survey' : '开始填写' }}</div>
        </div>
        <div v-else class="container"
            :style="{color: style.color || '#484848', background: baseStyle && (baseStyle.bgSrc || baseStyle.color) && baseStyle.opacity ? 'rgba(255, 255, 255, ' + baseStyle.opacity/100 + ')' : ''}">
            <img :src="baseStyle.header" class="header_img" width="100%" v-if="baseStyle && baseStyle.header">
            <div class="progress">
                <div class="progress-bar s-prog-wait" ref="progress">
                    <div class="progress-done s-prog-done" :style="{width: width + '%'}"></div>
                </div>
            </div>
            <div class="survey_cover_text">
                <div class="user" v-if="base.logintype == 1 && account">
                    <span class="username">欢迎您，{{account}}</span>
                    <a @click="showConfirm = true" href="javascript:void(0)">注销</a>
                </div>
            </div>
            <div class="questions">
                <QuestionMobile
                    :data="item"
                    v-on:itemClick="itemOnClick"
                    v-on:contentUpdate="contentOnUpdate"
                    v-on:itemContentUpdate="itemContentUpdate"
                    v-for="(item, index) in questions"
                    :textColor="style.color || ''"
                    :optionColor="baseStyle.optionColor"
                    :optionHighlightColor="baseStyle.optionHighlightColor"
                    :key="item.qid"
                    :sort="index + 1"
                    :isEn="isEOZ"
                ></QuestionMobile>
            </div>
            <div class="submmit" @click="submit()">{{ isEOZ ? 'Submit' : '提交' }}</div>
            <div class="tail"></div>
        </div>
        <ModalMask :show="showConfirm"></ModalMask>
        <Modal v-if="showConfirm">
            <confirm msg="确认要登出吗" v-on:close="showConfirm = false" v-on:confirm="confirm"></confirm>
        </Modal>
        <alert ref="alert" :isEn="isEOZ"></alert>
    </div>
</template>
<script>
  import * as types from '~/store/mutation-type';
  import store from '~/store/index';
//   import Footer from '~/components/Footer/footer.vue';
  import QuestionMobile from '~/components/QuestionMobile/question.vue';
  import api from '~/api/api';
  import { getParameterByName, rem, redirectTo, isMobile, getUrlParams, isWeiXin } from '~/tools/utils';
  import Mask from '~/components/Mask/mask.vue';
  import Modal from '~/components/Modal/modal.vue';
  import confirm from '~/components/confirm.vue';
  import DeviceDetector from "device-detector-js";
  import alert from '~/components/alert.vue';

  export default {
    components: {
        QuestionMobile,
        ModalMask: Mask,
        Modal,
        confirm,
        alert
    },
    data () {
        return {
          isLoading: false,
          activeRecord: [], // 规则命中记录
          step: 1,
          isHorizontal: window.innerWidth > window.innerHeight,
          isInIFrame: getParameterByName('iframe'),
          questions: null,
          showConfirm: false,
          base: {
            style: {}
          },
          baseStyle: {},
          style: {},
          account: '',
          glogin: null,
          showLogin: false,
          starttime: null,
          isEOZ: false
        }
    },
    computed: {
      width() {
          let val = this.finished*100/this.questionNum;
          console.log(val)
          return val
      },
      questionNum() {
          return this.questions ? this.questions.length : 1
      },
      finished() {
        let finishedAccount = 0;
        if(!this.questions) return 0
        for (let index = 0; index < this.questions.length; index++) {
            const element = this.questions[index];
            if(/^[1|4|5]/.test(element.qtype)) {
                let matchedIndex = element.options.findIndex(item => item.selected);
                // remark为包含填空
                if(matchedIndex >= 0 && (element.options[matchedIndex].remark != 1 || (element.options[matchedIndex].remark == 1 &&
                  (element.options[matchedIndex].content_required != 1 || (element.options[matchedIndex].content_required == 1 && element.options[matchedIndex].text))
                ))) {
                  finishedAccount++;
                }
            } else if(/^2/.test(element.qtype)) {
              let matchedItems = element.options.filter(item => item.selected);
              if(matchedItems.length && matchedItems.every(x => x.remark != 1 || (x.remark == 1 && (x.content_required != 1 || (x.content_required == 1 && x.text)) ))) {
                  finishedAccount++;
              }
            } else if(/^6/.test(element.qtype)) {
              if(element.rows.every(x => x.val >= 0)) {
                  finishedAccount++;
              }
            } else if(element.content) {
                finishedAccount++;
            }
        }
        return finishedAccount
      }
    },
    mounted() {
        let _this = this;
        if(!isMobile()) {
            let addr = location.href.split("#")
            location.replace(`${addr[0]}#/site${addr[1]}`)
        }
        rem();
        window.addEventListener('message', event => {
            // console.log('postMessage' + JSON.stringify(event.data));
            if(event.data == 'refresh') {
                this.init();
            }
        });

        Promise.all([
          this.unComplete('first'),
          this.init(),
          this.initLogin()
        ]).then(() => {
          if(this.base.logintype == 1 && !this.account) {
            this.glogin.login();
          }
          if(this.base.tags && this.base.tags.split(',').includes('EOZ')) {
            this.isEOZ = true;
            // 在head结束标签前插入下面的FB代码
            let script = document.createElement('script');
            script.text = `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '207592768792213');
              fbq('track', 'PageView');
            `;
            document.head.appendChild(script);
            let noscript = document.createElement('noscript');
            noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=207592768792213&ev=PageView&noscript=1" />`;
            document.head.appendChild(noscript);
          } else {
            // 设置页面标题
            document.title = '调查问卷';
          }
        })

        if(isWeiXin()) {
          window.addEventListener('pagehide', function() {
            _this.unComplete('first');
          });
        }

        window.onbeforeunload = function () {
          _this.unComplete('first');
        }
    },
    // watch: {
    //     glogin(val) {
    //         if(this.base.logintype == 1 && !this.account) {
    //             val.login();
    //         }
    //     }
    // },
    methods: {
      unComplete(tag) {
        const deviceDetector = new DeviceDetector();
        const device = deviceDetector.parse(window.navigator.userAgent);
        if(device.device && device.device.model === 'LIO-AN00') {
          device.device.model = 'Mate 30 Pro(5G)'
        }
        let baseUrl = process.env.VUE_APP_ENV == 'development' ? '/surveyapi' : process.env.VUE_APP_ENV == 'pre' ? '//gapi.dev.ztgame.com/surveyapi' : '//gapi.ztgame.com/surveyapi'
        fetch(`${baseUrl}/f/user/reply`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sid: this.$route.params.sid,
            starttime: tag ? '' : this.starttime,
            clientinfo: JSON.stringify(device),
            reply_status: -1
          }),
          keepalive: true // 保持连接
        })
      },
      initLogin() {
        return new Promise((resolve) => {
          let _this = this;
          if(!this.isInIFrame && process.env.VUE_APP_ENV !== 'development') {
            requirejs(['login/index'], gLogin => {
              _this.glogin = new gLogin({
                  type:'popup',
                  //设置 去注册按钮
                  fastreg:{
                      //注意：不支持回调函数
                      type: 'normal'
                  },
                  login_type: 27,
                  onLogin: function(result) {
                      if(result){
                          //登录成功
                          api.login({
                              sid: _this.$route.params.sid
                          }).then(res => {
                              if(!res) return;
                              _this.account = res.data.account;
                              if(res.replycount == 1) {
                                  store.commit(types.SHOW_MODAL, {
                                      name: 'message',
                                      msg: _this.isEOZ ? 'You have already completed this survey. Thank you for participating.' : '您已参加过该问卷调查哦，感谢您的参与~',
                                      isEn: _this.isEOZ
                                  });
                              }
                          });
                      } else{
                          //登录失败
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg, isEn: _this.isEOZ});
                      }
                  },
                  onLogout:function(result){
                      if(!!result&&!!result.status&&result.status>0){
                          //注销成功
                      }
                      else{
                          //注销失败
                          store.commit(types.SHOW_MODAL, {name: 'message', msg: result.msg, isEn: _this.isEOZ});
                      }
                  }
              });
              resolve()
            });
          } else {
            resolve()
          }
        })
      },
      shuffle(arr) {
        var len = arr.length;
        for(var i=0;i<len;i++){
            var end = len - 1 ;
            var index = (Math.random()*(end + 1)) >> 0;
            var t = arr[end];
            arr[end] = arr[index];
            arr[index] = t;
        }
        return arr;
      },
      confirm() {
          api.logout(this.$route.params.sid).then(res => {
              this.showConfirm = false;
              if(!res) return;
              this.account = '';
              if(!this.isInIFrame && this.base.logintype == 1) {
                  this.glogin.login();
              }
          }).catch(() => {
              this.showConfirm = false;
          });
      },
      groupByValues(arr, key1, key2) {
        return arr.reduce((result, current) => {
            const groupKey = current[key1] + ':' + current[key2];
            if (!result[groupKey]) {
            result[groupKey] = [];
            }
            result[groupKey].push(current);
            return result;
        }, {});
      },
      async init() {
        let _this = this;
        try {
          let res = await api.getInfo(this.$route.params.sid);
          if(!res) return;
          // 去掉问卷乱序随机
          // if(res.data.unorder == 1) {
          //   _this.questionsAll = _this.shuffle(JSON.parse(JSON.stringify(res.question)));
          // }
          _this.questionsAll = JSON.parse(JSON.stringify(res.question));
          // 去掉选项随机逻辑
          // _this.questionsAll = _this.questionsAll.map(x => {
          //     if(x.qtype == 2 && x.unorder == 1) {
          //         x.options = _this.shuffle(JSON.parse(JSON.stringify(x.options)));
          //     }
          //     return x;
          // });
          res.data.desc = res.data.desc.replace(/\n/g, "<br/>")
          _this.base = Object.assign({}, res.data);
          _this.baseStyle = Object.assign({}, res.data.style);
          if(_this.base.tags && _this.base.tags.split(',').includes('EOZ')) {
            _this.isEOZ = true;
          }
          if(_this.isEOZ) {
            _this.questionsAll.forEach(q => {
              if(q.options) {
                q.options.forEach(opt => {
                  if(opt.content === '其他') {
                    opt.content = 'Other';
                  }
                });
              }
            });
          }

          // const groupedByAge = this.groupByValues(res.logics, 'qid', 'target_qid');
          // var result = []
          // for (const key in groupedByAge) {
          //     var qoid = groupedByAge[key].map(item => item.qoid).join(',');
          //     result.push(Object.assign(groupedByAge[key][0], {qoid}))
          // }
          _this.oldLogics = res.logics;
          _this.logics = res.logicsv2;
          if(res.logics.length && !res.logicsv2.length) {
            this.$refs["alert"].openModal(_this.isEOZ ? 'This survey configuration has expired. Please contact the administrator.' : '该问卷配置已过期，请联系管理员~');
          } else if(_this.logics && _this.logics.length) {
            // 初始化把逻辑的目标问题隐藏
            _this.questionsAll.map(x => {
              if(_this.logics.some(logic => logic.target_qid === x.qid && logic.rule === 'show' )) {
                x.hide = true
              }
              return x;
            })
          }
          _this.questions = JSON.parse(JSON.stringify(_this.questionsAll)).filter(q => !q.hide);

          let style = _this.baseStyle;

          if (style) {
              if (style.bgSrc) {
                  _this.style = Object.assign({}, {
                    backgroundImage: `url(${style.bgSrc})`,
                    backgroundSize: 'cover'
                  });
              } else if (style.color) {
                  _this.style = Object.assign({}, {
                    backgroundColor: style.color
                  });
              }
              if (style.textColor) {
                  _this.style = Object.assign({}, _this.style, {
                    color: style.textColor
                  });
              }
          }
          if(res.user) {
              _this.account = res.user.account;
              _this.starttime = res.user.starttime;
          }
          if(!_this.isInIFrame && (_this.base.logintype == 2 || _this.base.logintype == 5)) {
              let params = getUrlParams();
              return api.login(Object.assign(params, {
                sid: this.$route.params.sid
              })).then(res => {
                if(!res) return;
                _this.account = res.data.account;
                if (res.errors && res.errors.error_message) {
                    store.commit(types.SHOW_MODAL, {name: 'message', msg: res.errors.error_message[0], isEn: _this.isEOZ});
                    return;
                }
                if(res.replycount == 1) {
                    store.commit(types.SHOW_MODAL, {
                      name: 'message',
                      msg: _this.isEOZ ? 'You have already completed this survey. Thank you for participating.' : `您已参加过该问卷调查哦，感谢您的参与~`,
                      isEn: _this.isEOZ
                    });
                }
              });
          }
        } catch (error) {
          console.log(error);
        }
      },
      itemContentUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.text = indexData.text;
                }
                return item;
              });
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item) => {
              item.text = indexData.text;
              return item;
            });
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      checkItemSelect(element){
        if(/^[1|4|5]/.test(element.qtype)) {
            let matchedIndex = element.options.findIndex(item => item.selected);
            // remark为包含填空
            if(!(matchedIndex >= 0 && (element.options[matchedIndex].remark != 1 || (element.options[matchedIndex].remark == 1 &&
              (element.options[matchedIndex].content_required != 1 || (element.options[matchedIndex].content_required == 1 && element.options[matchedIndex].text))
            ))) ){
              this.unComplete();
            }
        } else if(/^2/.test(element.qtype)) {
          let matchedItems = element.options.filter(item => item.selected);
          if(!(matchedItems.length && matchedItems.every(x => x.remark != 1 || (x.remark == 1 &&
          (x.content_required != 1 || (x.content_required == 1 && x.text)) )))) {
            this.unComplete();
          }
        } else if(/^6/.test(element.qtype)) {
          if(!(element.rows.every(x => x.val >= 0))) {
            this.unComplete();
          }
        } else if(!element.content) {
            this.unComplete();
        }
      },
      itemOnClick(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          this.checkItemSelect(questionData);
          this.questionsAll = this.questionsAll.map((item) => {
            item.selected = item.qid == indexData.qid ? true : false;
            return item;
          });

          if(indexData.qtype == 2) {
              // 多选题
              let currentState = questionData.options.find((item, index) => index == indexData.index).selected;
              // 先解决互斥选项
              if(!currentState) {
                let currentExclusion = questionData.options[indexData.index].is_exclusion
                questionData.options = questionData.options.map(item => {
                  if(currentExclusion === "1") {
                    item.selected = false;
                  } else { // 非互斥项，把互斥项的选中状态置为false
                    if(item.is_exclusion === "1") {
                      item.selected = false;
                    }
                  }
                  return item;
                });
                questionData.options.forEach((item, index) => {
                  if(currentExclusion === "1" && indexData.index != index) {
                    this.resetQuestions(questionData, index);
                  } else if(item.is_exclusion === "1") { // 非互斥项，把互斥项的选中状态置为false
                    this.resetQuestions(questionData, index);
                  }
                  return item;
                });
              }
              let selectedNum = questionData.options.filter(item => item.selected).length;
              if(!currentState && selectedNum === parseInt(questionData.maxnum)) {
                store.commit(types.SHOW_MODAL, {
                  name: 'message',
                  msg: this.isEOZ ? `Select up to ${questionData.maxnum} options for this question.` : `该题请至多选择${questionData.maxnum}项哦~`,
                  isEn: this.isEOZ
                });
                return;
              }
              questionData.options = questionData.options.map((item, index) => {
                if(index == indexData.index) {
                    item.selected = !item.selected;
                }
                return item;
              });
              this.resetQuestions(questionData, indexData.index);
          } else if(/^[1|4|5]/.test(indexData.qtype)) {
            // 单选题
            questionData.options = questionData.options.map((item, index) => {
              item.selected = index == indexData.index ? true : false;
              return item;
            });
            questionData.options.forEach((item, index) => {
                this.resetQuestions(questionData, index);
            })
          } else if(indexData.qtype == 6) {
              // 多选题
              questionData.rows[indexData.dIndex].val = indexData.index;
              questionData.options.forEach((item, index) => {
                this.resetQuestions(questionData, index, indexData.dIndex);
              })
          }
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
          console.log('questions', this.questions)
      },
      contentOnUpdate(indexData) {
          let questionData = this.questionsAll.find(q => q.qid == indexData.qid);
          questionData.content = indexData.content;
          this.questions = JSON.parse(JSON.stringify(this.questionsAll)).filter(q => !q.hide);
      },
      reCursiveHide(matchedIndex) {
        let src = this.questionsAll[matchedIndex];
        let qIndex = this.questions.findIndex(item => item.qid == src.qid);
        if(qIndex < 0) {
          return;
        }
        if(src.qtype == 6) {
          src.rows.map(item => {
            item.val = -1;
            return item;
          })
          src.rows.forEach((item, index) => {
            this.resetQuestions(src, 0, index);
          })
        } else if (/^[1|2|4|5]/.test(src.qtype)) {
          src.options.map(item => {
            item.selected = false;
            return item;
          })
          src.options.forEach((item, index) => {
            this.resetQuestions(src, index);
          })
        } else {
          src.content = ''
        }
      },
      resetQuestions(src, index, rowIndex) {
        let _this = this;
        this.logics.map(logic => {
          logic.conditions.map(condition => {
            if(src.qtype == 6) { // 矩阵题
              if(condition.qid == src.qid && src.rows[rowIndex].rid == condition.rid) {
                if(src.rows[rowIndex].val >= 0 && condition.oids.includes(src.options[src.rows[rowIndex].val].oid)) {
                  condition.active = true;
                } else {
                  condition.active = false;
                }
              }
            } else {
              if(condition.qid == src.qid) {
                let checkedOptions = src.options.filter(item => item.selected);
                condition.active = checkedOptions.some(item => condition.oids.includes(item.oid));
              }
            }
            return condition;
          })
          if(logic.condition_type === 'and') {
            logic.active = logic.conditions.every(condition => condition.active);
          } else if(logic.condition_type === 'or') {
            logic.active = logic.conditions.some(condition => condition.active);
          }
          let matchedIndex = _this.questionsAll.findIndex(q => q.qid == logic.target_qid);
          if(matchedIndex >= 0) {
            let prviousValue = _this.questionsAll[matchedIndex].hide;
            if(logic.rule === 'show') {
              _this.questionsAll[matchedIndex].hide = !logic.active;
            } else if(logic.rule === 'hide') {
              _this.questionsAll[matchedIndex].hide = logic.active;
            }
            if(!prviousValue && _this.questionsAll[matchedIndex].hide) {
              _this.reCursiveHide(matchedIndex)
            }
            _this.questions = JSON.parse(JSON.stringify(_this.questionsAll)).filter(q => !q.hide);
          }
          return logic;
        })
      },
      checkForm() {
          for (let index = 0; index < this.questions.length; index++) {
              const element = this.questions[index];
              if(/^[1|4|5]/.test(element.qtype)) {
                  let matchedIndex = element.options.findIndex(item => item.selected);
                  if(element.required == 1) {
                      if(matchedIndex == -1) {
                          store.commit(types.SHOW_MODAL, {
                            name: 'message',
                            msg: this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`,
                            isEn: this.isEOZ
                          });
                          return false;
                      }
                      // 其他项必填且未填时，校验失败
                      if(element.options[matchedIndex].remark == 1 &&
                        element.options[matchedIndex].content_required == 1 &&
                        !element.options[matchedIndex].text
                      ) {
                          store.commit(types.SHOW_MODAL, {
                            name: 'message',
                            msg: this.isEOZ ? `Please complete item ${matchedIndex + 1} in Question ${index + 1}.` : `请填写第${index + 1}题的第${matchedIndex + 1}个选项哦~`,
                            isEn: this.isEOZ
                          });
                          return false;
                      }
                  }
              } else if(/^2/.test(element.qtype)) {
                  let matchedItems = element.options.filter(item => item.selected);
                  if(element.required == 1) {
                      if(!matchedItems.length) {
                          store.commit(types.SHOW_MODAL, {
                            name: 'message',
                            msg: this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`,
                            isEn: this.isEOZ
                          });
                          return false;
                      }
                      if(!matchedItems[0].is_exclusion && matchedItems.length < parseInt(element.minnum)) {
                          store.commit(types.SHOW_MODAL, {
                            name: 'message',
                            msg: this.isEOZ ? `Select at least ${element.minnum} options for Question ${index + 1}.` : `第${index + 1}题请至少选择${element.minnum}项哦~`,
                            isEn: this.isEOZ
                          });
                          return false;
                      }
                      if(matchedItems.length > parseInt(element.maxnum)) {
                          store.commit(types.SHOW_MODAL, {
                            name: 'message',
                            msg: this.isEOZ ? `Select up to ${element.maxnum} options for Question ${index + 1}.` : `第${index + 1}题请至多选择${element.maxnum}项哦~`,
                            isEn: this.isEOZ
                          });
                          return false;
                      }
                      for (let j = 0; j < matchedItems.length; j++) {
                          const ele = matchedItems[j];
                          // 其他项必填且未填时，校验失败
                          if(ele.remark == 1 &&
                              ele.content_required == 1 &&
                              !ele.text
                          ) {
                              store.commit(types.SHOW_MODAL, {
                                name: 'message',
                                msg: this.isEOZ ? `Please complete Question ${index + 1}.` : `请填写第${index + 1}题的选项哦~`,
                                isEn: this.isEOZ
                              });
                              return false;
                          }
                      }
                  }
              } else if(/^6/.test(element.qtype)) {
                  //TODO:
              } else {
                  if(element.required == 1 && !element.content) {
                      store.commit(types.SHOW_MODAL, {
                        name: 'message',
                        msg: this.isEOZ ? `Please answer Question ${index + 1}.` : `请回答第${index + 1}题哦~`,
                        isEn: this.isEOZ
                      });
                      return false;
                  }
                  if((element.qtype == 3 || element.qtype == 307) &&
                    parseInt(element.alength) > 0 &&
                    element.content &&
                    this.getCharLength(element.content) > parseInt(element.alength)
                  ) {
                      store.commit(types.SHOW_MODAL, {
                        name: 'message',
                        msg: this.isEOZ ? `Your response to Question ${index + 1} exceeds the character limit.` : `第${index + 1}题超过字数限制哦`,
                        isEn: this.isEOZ
                      });
                      return false;
                  }
              }
          }
          return true;
      },
      getCharLength(str) {
        //获得字符串实际长度，中文2，英文1
        //要获得长度的字符串
        var realLength = 0, len = str.length, charCode = -1;
        for (var i = 0; i < len; i++) {
            charCode = str.charCodeAt(i);
            if (charCode >= 0 && charCode <= 128)
            realLength += 1;
            else
            realLength += 2;
        }
        return realLength;
      },
      submit() {
          if(this.isLoading) {
            return;
          }
          if(this.oldLogics.length && !this.logics.length) {
            this.$refs["alert"].openModal(this.isEOZ ? 'This survey configuration has expired. Please contact the administrator.' : '该问卷配置已过期，请联系管理员~');
            return;
          }
          if(!this.checkForm()) {
            //   store.commit(types.SHOW_MODAL, {name: 'message', msg: '请把表单填写完整哦~'});
              return;
          }
          let data = [];
          this.questions.forEach((x) => {
            if(/^[1|4|5]/.test(x.qtype)) {
              let matchedItem = x.options.find(item => item.selected);
              if(matchedItem) {
                data.push({
                  qid: x.qid, oid: matchedItem.oid, content: matchedItem.remark == 1 ? matchedItem.text : matchedItem.content
                });
              }
            } else if (/^2/.test(x.qtype)) {
              let matchedItems = x.options.filter(item => item.selected);
              matchedItems.forEach(item => {
                data.push({
                  qid: x.qid, oid: item.oid, content: item.remark == 1 ? item.text : item.content
                });
              });
            } else if (/^6/.test(x.qtype))  {
              x.rows.forEach(item => {
                if(item.val >= 0) {
                  data.push({
                    qid: x.qid,
                    rid: item.rid,
                    oid: x.options[item.val].oid
                  });
                }
              })
            } else {
              data.push({
                qid: x.qid,
                content: x.content
              });
            }
          });
          const deviceDetector = new DeviceDetector();
          const device = deviceDetector.parse(window.navigator.userAgent);
          if(device.device && device.device.model === 'LIO-AN00') {
              device.device.model = 'Mate 30 Pro(5G)'
          }
          this.isLoading = true;
          api.submit({
            sid: this.$route.params.sid,
            answers: data,
            starttime: this.starttime,
            clientinfo: JSON.stringify(device),
          }).then(res => {
            this.isLoading = false;
            if(res) {
              this.submitted = true;
              this.$refs["alert"].openModal(this.base.endmsg).then(() => {
                  if(res.redirecturl) {
                      location.href = res.redirecturl;
                  }
                  if(res.callbackmsg) {
                      redirectTo(res.callbackmsg)
                  }
              })
              console.log("surveyfinish");
              if(this.isEOZ) {
                window.fbq && window.fbq('track', 'CompleteRegistration');
                // 如果所有题目都回答完，包括非必填的
                if(this.finished === this.questionNum) {
                  window.fbq && window.fbq('track', 'Lead');
                }
              }
            }
          }).catch(() => {
            this.isLoading = false;
          });
      }
    }
  }
</script>
<style lang="stylus" scoped>
  /deep/.app
    width 100%
    height 100%
</style>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
    .pg-answer
        position relative
        width 100%
        height 100%
        font-size: 16px;
        .step1
          width 100%
          height 100vh
          background-color #e0edfe
          background-image url('./images/mbg.png')
          background-size contain
          background-repeat no-repeat
          background-position top center
          padding 30% 25px 0
          color: #484848;
          &.horizontal
            background-image url('./images/bg.png')
            background-size cover
            padding 10% 50px 0
          .TopBgTitle
              font-size: 28px;
              font-weight: 500;
              text-align center;
          .desc_begin
              font-size: 16px;
              line-height 1.5
              margin: 20px 0 0;
          .submmit
            position: absolute;
            bottom: 0.3rem;
            left: 50%;
            margin-left: -2.7rem;
            padding-bottom: calc(constant(safe-area-inset-bottom) + 0.3rem);
            padding-bottom: calc(env(safe-area-inset-bottom) + 0.3rem)/* 兼容 iOS < 11.2 */
        &.with-bg {
          padding 0.10rem;
        }
        .progress {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          padding: 5px 12px;
          background-color: #E3E3E5;
          z-index: 50;
          position: fixed;
          &-bar {
            flex: 1 1;
            height: 3px;
            background-color: #FFFFFF;
            border-radius: 3px;
            transform: translate3d(0, 0, 0);
            overflow: hidden;
          }
          &-done {
            width: 0;
            height: 100%;
            background-color: #008FFF;
            transition: 0.3s;
          }
        }
        .submmit
          margin 0.90rem auto 0
          width 5.40rem;
          text-align: center;
          text-decoration: none;
          color: #ffffff;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          border-radius: 6px;
          letter-spacing 0.10rem;
          cursor: pointer;
          background-color: #2672FF;
          box-shadow: 0 3px 6px rgba(0, 0, 0, 0.07);
        .container
            width 100%
            height 100%
            min-height 100vh
            overflow-y scroll
            background-color #e0edfe
            .survey_cover_text
                margin: 0 0.50rem;
                padding: 0.30rem 0 0.12rem;
                background-color: transparent;
                box-shadow: none;
                .wjhr
                    background-color: #53a4f4!important;
                    width: 100%;
                    height: 0.03rem;
                    margin-top: 0.20rem;
                .user {
                    float right
                    font-size: 0.20rem;
                    margin-top  0.20rem
                    .username {
                        margin-right 0.10rem
                    }
                    i {
                        &:hover {
                            color red
                        }
                    }
                }
            .questions
                width 100%
                display flex
                flex-direction column
                justify-content center
            .tail
                height 0.30rem;
                width 100%
</style>
